import { FLOOR_KEY } from 'common/consts/local-storage-key.const';
import { TFloorParams } from 'common/types/floor-params.type';
import { getCalculatedRooms } from 'pages/dimensions/helpers/get-calculated-rooms.helper';
import { MAX_STORAGE_LENGTH } from 'common/consts/max-storage-length';
import { getBodyForCalculationStorage } from './get-body-for-calculate-storage.helper';
import { storageManager } from './local-storege-manager.helper';
import { getHasSameParams } from './get-has-same-params.helper';

type TSetInputParamsInStorage = {
  inputParams: TFloorParams;
  calculatorId: string;
};

export const setInputParamsInStorage = ({ inputParams, calculatorId }: TSetInputParamsInStorage): void => {
  const bodyForStorage = getBodyForCalculationStorage({ inputParams, calculatorId });
  const dataInStorage = getCalculatedRooms() || [];

  // Проверяем, есть ли в localStorage данные с такими же параметрами
  const hasSameParams = getHasSameParams({ dataInStorage, inputParams });
  //  если есть, то не сохраняем ничего
  if (hasSameParams) return;

  // Если в хранилище меньше 3 элементов, добавляем новый элемент
  if (dataInStorage.length < MAX_STORAGE_LENGTH) {
    dataInStorage.push(bodyForStorage);
  } else {
    // если уже три элемента в хранилище, заменяем самый ранний элемент на новый
    const earliestIndex = dataInStorage.reduce(
      (earliest, current, index) =>
        new Date(current.createdDate) < new Date(dataInStorage[earliest].createdDate) ? index : earliest,
      0
    );
    dataInStorage[earliestIndex] = bodyForStorage;
  }

  storageManager.setItem(FLOOR_KEY, dataInStorage);
};
